export default "__VITE_ASSET__8k7SWe5y__"